import { isUndefinedOrNull } from './usefulFuncs';
import { logError } from './usefulFuncs';
import { getAdvancedSettingsForMode } from '@constants/advancedSettings';

export const getDefaultToolAdvancedSettingValues = (tool) => {
  const entry = getAdvancedSettingsForMode(tool);
  if (!entry) {
    logError('No defined starting advanced setting values for tool', tool);
    return null;
  }
  return entry.startingValues;
};

export const getToolAdvancedSettingsFields = (tool) => {
  const entry = getAdvancedSettingsForMode(tool);
  if (!entry) {
    logError('No defined advanced setting fields for tool', tool);
    return [];
  }
  return entry.fields;
};

export function addOptionalBoolField(name, value, form) {
  if (value === '') {
    return;
  }
  form[name] = value;
}

export function addOptionalOnOffField(name, value, form) {
  if (value === '' || !value) {
    return;
  }
  form[name] = value;
}

export function addOptionalFreeField(name, value, form) {
  if (!isUndefinedOrNull(value)) {
    form[name] = value;
  }
}

export function addOptionalField(name, value, form, isFloat) {
  if (!isNaN(value) && value !== '') {
    form[name] = isFloat ? parseFloat(value) : parseInt(value, 10);
  }
}
